import { Option } from "../../common/commonSelect2";

export const genderOption = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];

export const chooseOption = [
  { label: "Option 1", value: "1" },
  { label: "Option 2", value: "2" },
  { label: "Option 3", value: "3" },
];

export const programOption = [
  { label: "Chennai", value: "chennai" },
  { label: "Gurgaon", value: "gurgaon" },
  { label: "Hyderabad", value: "hyderabad" },
  { label: "Indore - Sapphire", value: "indore - sapphire" },
  { label: "Jaipur - LIC", value: "jaipur - lic" },
  { label: "Jaipur - MNS", value: "jaipur - mns" },
  { label: "Kolkata - GWS", value: "kolkata - gws" },
  { label: "Kolkata - Smartwork", value: "kolkata - smartwork" },
  { label: "Malad", value: "malad" },
  { label: "Mohali - A-40", value: "mohali - a-40" },
  { label: "Mohali - Bestech", value: "mohali - bestech" },
  { label: "Noida", value: "noida" },
  { label: "Thane", value: "thane" },
];

export const dashboardSbuOption: Record<string, Option[]> = {
  gurgaon: [
    // { label: "All", value: "all" },
    { label: "AIRBNB", value: "airbnb" },
    { label: "FIS", value: "fis" },
    { label: "VERIZON", value: "verizon" },
  ],
};

export const countryOptions = [
  {
    label: "IN",
    value: "+91",
    country: "India",
  },
  {
    label: "US",
    value: "+1",
    country: "United States",
  },
  {
    label: "UK",
    value: "+44",
    country: "United Kingdom",
  },
  {
    label: "AU",
    value: "+61",
    country: "Australia",
  },
  {
    label: "DE",
    value: "+49",
    country: "Germany",
  },
  {
    label: "FR",
    value: "+33",
    country: "France",
  },
  {
    label: "SG",
    value: "+65",
    country: "Singapore",
  },
  {
    label: "UAE",
    value: "+971",
    country: "United Arab Emirates",
  },
  {
    label: "JP",
    value: "+81",
    country: "Japan",
  },
  {
    label: "CN",
    value: "+86",
    country: "China",
  },
  {
    label: "BR",
    value: "+55",
    country: "Brazil",
  },
  {
    label: "ZA",
    value: "+27",
    country: "South Africa",
  },
  {
    label: "NZ",
    value: "+64",
    country: "New Zealand",
  },
  {
    label: "MY",
    value: "+60",
    country: "Malaysia",
  },
];

// -------------- Filter-track-case options ---------------
export const clientOptions = [
  // {
  //   label: "Teleperformance Global Services Private Limited",
  //   value: "teleperformance-global-services-private-limited",
  // },
  {
    label: "Tech Mahindra Limited",
    value: "tech-mahindra",
  },
];

export const geoOptions = [{ label: "India", value: "india" }];

export const sbuOptions = [
  { label: "AIRTEL", value: "airtel" },
  { label: "DISHTV", value: "dishtv" },
  { label: "AMDOCS", value: "amdocs" },
];

export const packageOptions = [
  { label: "Airtel - FULL", value: "airtel_full" },
  { label: "Airtel FULL PA", value: "airtel_full_pa" },
];

export const departmentOptions = [{ label: "Gurugram", value: "gurugram" }];

export const userOptions = [
  { label: "Jai Khare", value: "jai-khare" },
  { label: "Shubham Pal", value: "shubham-pal" },
  { label: "Shreyesh Kohli", value: "shreyesh-kohli" },
  { label: "Vishal Kumar", value: "vishal-kumar" },
  { label: "Abhishek Gupta", value: "abhishek-gupta" },
  { label: "Aman Singh", value: "aman-singh" },
  { label: "Madesh M", value: "madesh-m" },
];
// -------------- /Filter-track-case options ---------------

// -------------- Masters - Vishnu options ---------------

export const riskMatrixOptions = [
  { label: "Criminal check via E-Court", value: "criminal" },
  { label: "Education", value: "education" },
  { label: "Address", value: "address" },
  { label: "International Employment", value: "internationalEmployment" },
  { label: "International Education", value: "internationalEducation" },
  { label: "Aadhar Number Validation", value: "aadharValidation" },
  { label: "Drug Test - Panel 5", value: "drugTestPanel5" },
  { label: "Office of Foreign Assets Control (OFAC/SDN)", value: "ofac" },
  { label: "Aadhar KYC", value: "aadharKyc" },

  { label: "Global Database Check", value: "globalDatabaseCheck" },
  { label: "Drug Test - Panel 10", value: "drugTestPanel10" },
  { label: "Criminal Check Via Law Firm", value: "criminalCheckViaLawFirm" },
  { label: "Pan Card", value: "panCard" },
  { label: "Employment", value: "employment" },
];

export const roleNameOptions = [
  { label: "VENDOR", value: "vendor" },
  { label: "Client Admin", value: "clientAdmin" },
  {
    label: "Client Account Manager - Bulk Submission",
    value: "clientAccountManagerBulkSubmission",
  },
  {
    label: "Client Account Manager",
    value: "clientAccountManager",
  },
];

export const hrApprovalOptions = [
  {
    label:
      "HR will provide approval for forms submitted by candidate. If not approved by HR, it will auto approve in 4 days",
    value: "hrApproval",
  },
  {
    label:
      "Form submitted by candidate will go directly to Aupertz processing. Client HR does not need to approve cases",
    value: "directProcessing",
  },
];
// -------------- /Masters - Vishnu options ---------------
